import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {deleteRegulatoryBody, hideDeleteRegulatoryBodyModal} from "./actions";
import DeleteFormModal from "../common/DeleteFormModal";

const DeleteRegulatoryBodyModal = ({onDelete, regulatoryBody, regulatoryBodyDeleting, hideDeleteRegulatoryBodyModal, deleteRegulatoryBody, visible}) => {
  const regulatoryBodyHandle = {regulatoryBodyId: regulatoryBody.regulatoryBodyId};
  return (
    <DeleteFormModal entityType="Regulatory Body" entityName={regulatoryBody.name} entityHandle={regulatoryBodyHandle} visible={visible}
                     entityDeleting={regulatoryBodyDeleting} deleteEntity={deleteRegulatoryBody}
                     hideDeleteFormModal={hideDeleteRegulatoryBodyModal} onDelete={onDelete}/>);
};

DeleteRegulatoryBodyModal.propTypes = {
  onDelete: PropTypes.func.isRequired,
  /* state */
  visible: PropTypes.bool.isRequired,
  regulatoryBody: PropTypes.object,
  regulatoryBodyDeleting: PropTypes.bool.isRequired,
  /* actions */
  hideDeleteRegulatoryBodyModal: PropTypes.func.isRequired,
  deleteRegulatoryBody: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  visible: state.regulatoryBody.deleteRegulatoryBodyModalVisible,
  regulatoryBody: state.regulatoryBody.regulatoryBodyToDelete,
  regulatoryBodyDeleting: state.regulatoryBody.regulatoryBodyDeleting,
});

const mapDispatchToProps = dispatch => ({
  hideDeleteRegulatoryBodyModal: bindActionCreators(hideDeleteRegulatoryBodyModal, dispatch),
  deleteRegulatoryBody: bindActionCreators(deleteRegulatoryBody, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteRegulatoryBodyModal);



// WEBPACK FOOTER //
// ./src/RegulatoryBody/DeleteRegulatoryBodyFormModal.js